import { authenticatedPost, authenticatedGet } from "../../../../Services/core";

export const addTemplate = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'document-template/add');
}

export const listTemplate = async (request) => {
   return await authenticatedPost(request, process.env.REACT_APP_BASE_URL+'document-template/list');
}
